import NotificationsModel from './notifications-model';
import NotificationsView from './notifications-view';

export default class NotificationsPresenter {
  constructor(model, view, appInterface) {
    this.model = model || new NotificationsModel();
    this.view = view || new NotificationsView();
    this.appInterface = appInterface || this.createDefaultAppInterface();
  }

  createDefaultAppInterface() {
    return {
      showToast: (message, type, duration) => {
        if (window.app && window.app.showToast) {
          window.app.showToast(message, type, duration);
        }
      },
      enableNotifications: () => {
        if (window.app && window.app.enableNotifications) {
          window.app.enableNotifications();
        }
      },
      unsubscribeFromNotifications: () => {
        if (window.app && window.app.unsubscribeFromNotifications) {
          window.app.unsubscribeFromNotifications();
        }
      },
      navigateTo: (page) => {
        if (window.app && window.app.navigateTo) {
          window.app.navigateTo(page);
        }
      },
      reinitTooltips: () => {
        if (window.app && window.app.tooltip && window.app.tooltip.reinit) {
          window.app.tooltip.reinit();
        }
      },
      isAuthenticated: () => {
        return window.app?.isAuthenticated || false;
      },
      updateNotificationBubble: () => {
        if (window.app && window.app.updateNotificationBubble) {
          window.app.updateNotificationBubble();
        }
      },
      removeNotificationFromApp: (notificationId) => {
        if (window.app && window.app.removeNotificationFromApp) {
          window.app.removeNotificationFromApp(notificationId);
        }
      }
    };
  }

  async init() {
    this.model.loadUserState();
    
    if (!this.model.isAuthenticated) {
      this.showAuthRequired();
      return;
    }
    
    this.loadNotifications();
    this.setupEventListeners();
    this.updateNotificationButtonState();
  }

  showAuthRequired() {
    this.view.showAuthRequired('#notifications-container');
  }

  loadNotifications() {
    const notifications = this.model.getNotifications();
    this.view.renderNotifications(notifications, '#notifications-container');
    
    this.appInterface.reinitTooltips();
  }

  setupEventListeners() {
    this.view.setupNotificationButtonEventListener(() => this.toggleNotifications());
    this.view.setupNotificationInteractionEventListeners((notificationId) => this.deleteNotification(notificationId));
  }

  toggleNotifications() {
    if (this.model.isPushSubscribed()) {
      this.appInterface.unsubscribeFromNotifications();
    } else {
      this.appInterface.enableNotifications();
    }
  }

  deleteNotification(notificationId) {
    const success = this.model.removeNotification(notificationId);
    
    if (success) {
      this.view.removeNotificationFromDOM(notificationId);
      
      if (window.app && window.app.removeNotificationFromApp) {
        window.app.removeNotificationFromApp(notificationId);
      }
      
      this.appInterface.showToast('Notifikasi dihapus', 'success');
      
      const remainingNotifications = this.model.getNotifications();
      if (remainingNotifications.length === 0) {
        this.view.showEmptyState('#notifications-container', 'Belum ada notifikasi');
      }
    }
  }

  updateNotificationButtonState() {
    const isSubscribed = this.model.isPushSubscribed();
    this.view.updateNotificationButton(isSubscribed);
  }

  addNotification(title, message) {
    if (!this.model.isAuthenticated) return;
    
    const notification = this.model.addNotification(title, message);
    this.appInterface.updateNotificationBubble();
    
    // Refresh tampilan jika sedang di halaman notifications
    if (this.appInterface.getCurrentPage && this.appInterface.getCurrentPage() === 'notifications') {
      this.loadNotifications();
    }
    
    return notification;
  }

  updateNotificationButton(isSubscribed) {
    this.model.setPushSubscription(isSubscribed ? {} : null);
    this.view.updateNotificationButton(isSubscribed);
  }

  cleanup() {
    this.view.cleanup();
  }

  refresh() {
    this.loadNotifications();
  }
}